import React, { useState } from 'react';

import styles from './HelpBox.module.scss';
import {
  helpColumnContent,
  DESTINATION_STEP,
  TAX_WITHHOLDING_NOTICE_STEP,
  SF_FREQUENCY_STEP,
  FREQUENCY_STEP,
  STATE_CODES,
} from '../../settings/settings';
import {
  getUserStateWithholdingRules,
  getWithholdingStateData
} from '../../redux/modules/stateWithholding/stateWithholding.selectors';
import { EXIT_MODAL } from '../../redux/modules/modals/modals.module';
import ModalLink from '../Shared/Modal/ModalLink/ModalLink';
import { useSelector } from 'react-redux';
import {
  getHouseholdEntityName,
  getUserAddress,
} from '../../redux/modules/PersonalInformation/personalInformation.selectors';
import { getSalesforceRep } from '../../redux/modules/applicationConfig/applicationConfig.selectors';
import StateDisclosureContent from "../StateDisclosureContent/StateDisclosureContent";

const HelpBox = ({ step, openBox }) => {
  const isSalesforceRep = useSelector((state) => getSalesforceRep(state));

  // Check if we need alternate text for SF
  let derivedContent = helpColumnContent[step];
  if (isSalesforceRep && FREQUENCY_STEP === step) {
    derivedContent = helpColumnContent[SF_FREQUENCY_STEP];
  }
  const userAddress = useSelector(getUserAddress);
  const content = derivedContent;
  const setStateValue = openBox || false;
  const [isVisible, setVisible] = useState(setStateValue);
  const householdEntityName = useSelector(getHouseholdEntityName);
  const stateWithholdingRules = useSelector(getWithholdingStateData);
  const stateWithholdingpercent = stateWithholdingRules?.find(
    (fund) => fund.stateCode === userAddress.state
  );
  const showCustomize =
    (householdEntityName === 'Enhanced Personal Services' ||
      householdEntityName === 'Personal Services') &&
    step === 'distribution';
  const subTopics = (content?.subTopics || []).filter((subTopic) => {
    if (!showCustomize) {
      return subTopic.key !== 'CUSTOMIZE';
    }
    return true;
  });
  const stateWithholdingData = useSelector(getUserStateWithholdingRules);

  return (
    <div className={styles.container}>
      <div
        className={`${styles.background} ${
          isVisible ? styles['open'] : styles['closed']
        }`}
      >
        {!isVisible && (
          <div
            className={styles.overlayClickable}
            onClick={() => setVisible(!isVisible)}
            id={`open-${step}-help`}
          />
        )}
        <div
          className={
            styles[
              !(step === 'tax-withholding-notice' && openBox)
                ? 'rmd-title-container'
                : 'rmd-title-container-notice'
            ]
          }
        >
          {isSalesforceRep && step === TAX_WITHHOLDING_NOTICE_STEP ? null : (
            <img
              src={require('../../assets/images/helperIcon.svg')}
              alt=""
              className={styles['helper-img']}
            />
          )}
          <div
            className={`${styles['title']} ${
              isVisible && styles['open-title']
            }`}
          >
            {openBox && isVisible
              ? isSalesforceRep && step === TAX_WITHHOLDING_NOTICE_STEP
                ? null
                : content.altTitle
              : content.title}
          </div>
        </div>

        <div className={styles['text-container']}>
          {isVisible &&
          isSalesforceRep &&
          step === TAX_WITHHOLDING_NOTICE_STEP ? (
            <>
              <div className={styles['market-volatility-note-box']}>
                <strong>Federal & State Income Tax Withholding Notice</strong>
                <div className={styles['market-volatility-note']}>
                  <li className={styles.subHeading}>
                    <strong>
                      Launch the current{' '}
                      <a
                        href="https://troweprice.atlassian.net/wiki/spaces/retailkms/pages/152799150/Templates+And+Disclosures"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles['link-text']}
                      >
                        federal withholding discolsures.
                      </a>
                    </strong>
                  </li>
                </div>
              </div>
              <div className={styles['market-volatility-note-box']}>
                <div className={styles['market-volatility-note']}>
                  <strong>State Income Tax Withholding Disclosure</strong>
                  {subTopics.map((topic, key) => (
                    <div key={key}>
                      {topic.title && (
                        <div className={styles.subHeading}>{topic.title}</div>
                      )}
                      {topic.description.map((content, key) => (
                        <div key={key} className={styles.subDescription}>
                          {topic.emphasis && (
                            <span className={styles['emphasis']}>
                              {topic.emphasis}
                            </span>
                          )}
                          {content}
                          {topic.link && step === TAX_WITHHOLDING_NOTICE_STEP && (
                            <span>
                              {' '}
                              <a
                                href="https://www.irs.gov/pub/irs-prior/fw4r--2022.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {topic.link.text}
                              </a>{' '}
                              <span>{topic.link.description}</span>
                            </span>
                          )}
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            </>
          ) : (
            isVisible &&
            subTopics.map((topic, key) => (
              <div key={key}>
                {topic.title && (
                  <div className={styles.subHeading}>{topic.title}</div>
                )}
                {topic.description.map((content, key) => (
                  <div key={key} className={styles.subDescription}>
                    {topic.emphasis && (
                      <span className={styles['emphasis']}>
                        {topic.emphasis}
                      </span>
                    )}
                    {content}
                    {topic.link && step === TAX_WITHHOLDING_NOTICE_STEP && (
                      <span>
                        {' '}
                        <a
                          href="https://www.irs.gov/pub/irs-prior/fw4r--2022.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {topic.link.text}
                        </a>{' '}
                        <span>{topic.link.description}</span>
                      </span>
                    )}
                  </div>
                ))}
                {!isSalesforceRep &&
                  topic.link &&
                  step !== TAX_WITHHOLDING_NOTICE_STEP && (
                    <div className={styles['link-container']}>
                      <ModalLink
                        link={
                          <div className={styles.link}>{topic.link.text}</div>
                        }
                        linkStyle="link"
                        modalProps={{
                          url: topic.link.url,
                          description: topic.link.description,
                        }}
                        modalName={EXIT_MODAL}
                      />
                    </div>
                  )}
              </div>
            ))
          )}
        </div>

        {
          <div className={styles['auto-rmd-helpbox-close-button-container']}>
            <div></div>
            <div
              className={`${styles['view-change-btn']} ${
                isVisible ? styles.openBlog : ''
              }`}
              onClick={() => {
                setVisible(!isVisible);
              }}
              id={`close-${step}-help`}
            >
              {openBox && isVisible && 'Close'}
            </div>
          </div>
        }
      </div>
    </div>
  );
};

HelpBox.defaultProps = {
  step: DESTINATION_STEP,
};

export default HelpBox;
